import React from 'react';

import AuthUserContext from './context';
import { onAuthUserListener } from '../firebase/api/auth';
import { redirect } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import WithRouter from '../helpers/WithRouter';

const withAuthentication = Component => {
    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                authUser: JSON.parse(localStorage.getItem('authUser')),
                authLoading: false,
            };
        }

        componentDidMount() {
            this.listener = onAuthUserListener(
                authUser => {
                    localStorage.setItem('authUser', JSON.stringify(authUser));
                    this.setState({ authUser: { ...authUser }, authLoading: false });
                    if (
                        !this.props.location.pathname.includes('/preview/') &&
                        !this.props.location.pathname.includes('/stripe/redirect')
                    ) {
                        redirect(
                            authUser.acceptPolicy && !authUser.alreadySeeWelcomePopup
                                ? `${ROUTES.POSTS}?welcome=true`
                                : this.props.location.pathname ?? ROUTES.POSTS
                        );
                    }
                },
                () => {
                    localStorage.removeItem('authUser');
                    this.setState({ authUser: null, authLoading: false });
                }
            );
        }

        componentWillUnmount() {
            this.listener();
        }

        updateAuthUser = changes => {
            this.setState({
                authUser: {
                    ...this.state.authUser,
                    ...changes,
                },
                authLoading: this.state.authLoading,
            });
        };

        updateAuthLoading = value => {
            this.setState({
                authUser: this.state.authUser,
                authLoading: value,
            });
        };

        render() {
            return (
                <AuthUserContext.Provider
                    value={{
                        authUser: this.state.authUser,
                        updateAuthUser: this.updateAuthUser,
                        authLoading: this.state.authLoading,
                        setAuthLoading: this.updateAuthLoading,
                    }}
                >
                    <Component {...this.props} />
                </AuthUserContext.Provider>
            );
        }
    }

    return WithRouter(WithAuthentication);
};

// const withAuthentication = Component => props => {

//     const [ authUser, setAuthUser ] = useState(JSON.parse(localStorage.getItem('authUser')))
//     const [ authLoading, setAuthLoading ] = useState(false)
//     const location = useLocation()

//     // const authUser = JSON.parse(localStorage.getItem('authUser'))

//     onAuthUserListener(
//         authUser => {
//             localStorage.setItem('authUser', JSON.stringify(authUser));
//             setAuthUser(authUser)
//             if (
//                 !location.pathname.includes('/preview/') &&
//                 !location.pathname.includes('/stripe/redirect')
//             ) {
//                 redirect(
//                     authUser.acceptPolicy && !authUser.alreadySeeWelcomePopup
//                         ? `${ROUTES.POSTS}?welcome=true`
//                         : location.pathname ?? ROUTES.POSTS
//                 );
//             }
//         },
//         () => {
//             localStorage.removeItem('authUser');
//             setAuthUser(null);
//         }
//     );

//     useEffect(() => {
//         const listener = onAuthUserListener(
//             authUser => {
//                 localStorage.setItem('authUser', JSON.stringify(authUser));
//                 this.setState({ authUser: { ...authUser } });
//                 if (
//                     !this.props.location.pathname.includes('/preview/') &&
//                     !this.props.location.pathname.includes('/stripe/redirect')
//                 ) {
//                     redirect(
//                         authUser.acceptPolicy && !authUser.alreadySeeWelcomePopup
//                             ? `${ROUTES.POSTS}?welcome=true`
//                             : this.props.location.pathname ?? ROUTES.POSTS
//                     );
//                 }
//             },
//             () => {
//                 localStorage.removeItem('authUser');
//                 this.setState({ authUser: null });
//             }
//         )
//         return () => listener()
//     }, [])

//     const updateAuthUser = changes => {
//         setAuthUser({
//                 ...authUser,
//                 ...changes,
//         });
//     };

//     const updateAuthLoading = () => {
//         setAuthLoading(prevValue => !prevValue)
//     }

//     return (
//         <AuthUserContext.Provider
//             value={{ authUser: authUser, updateAuthUser: updateAuthUser, authLoading, updateAuthLoading }}
//         >
//             <Component {...props} />
//         </AuthUserContext.Provider>
//     );
// };

export default withAuthentication;
